<script setup lang="ts">
const { trackEvent } = useTracking()
const { locale, t } = useI18n()

const path = computed(() => {
  switch (locale.value) {
    case 'fr':
      return '/fr/location-villas-luxe/piscine-privee'
    case 'en':
    default:
      return '/en/luxury-villas-rentals/private-pool'
  }
})

const onClickHotDeals = () =>
  trackEvent({
    event: 'homepage_favourites_click',
    suggestion: 'house',
  })
</script>

<template>
  <BaseContainer class="bg-gray-100 py-8 lg:max-w-full">
    <BaseRow class="lg:items-center lg:justify-center">
      <BaseCol cols="24" md="12" sm="24">
        <BaseSectionContent :title="t('title')">
          <template #header>
            <p class="mb-8 max-w-screen-sm">
              {{ t('text') }}
            </p>
            <BaseButton
              class="items-center text-lg"
              color="secondary"
              size="xl"
              :to="path"
              @click.prevent="onClickHotDeals"
            >
              {{ t('cta') }}
            </BaseButton>
          </template>
        </BaseSectionContent>
      </BaseCol>
      <BaseCol cols="24" md="12" sm="24" class="pt-8 sm:pt-0">
        <BaseNuxtImg
          alt="Summer bestsellers"
          class="lg:p-20"
          height="365"
          loading="lazy"
          src="production/assets/images/homepage/summer-forever-2025.webp"
          width="547"
        />
      </BaseCol>
    </BaseRow>
  </BaseContainer>
</template>

<i18n lang="json">
{
  "en": {
    "title": "Summer forever",
    "text": "It's not too late to book your holiday in the sun. Some of our most beautiful summer homes are still available for last-minute bookings!",
    "cta": "Discover our homes"
  },
  "fr": {
    "title": "Summer forever",
    "text": "Il n’est pas trop tard pour réserver vos vacances sous le soleil. Certaines de nos plus belles maisons d’été sont encore disponibles en dernière minute !",
    "cta": "Explorez nos maisons"
  }
}
</i18n>
